export default "__VITE_ASSET__c68d42a0__"